var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClustersArc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 41,
    viewBox: "0 0 44 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#EDECE8",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 35,
    r: 4,
    fill: "#EDECE8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 13,
    r: 9,
    fill: "#EDECE8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 19.5,
    r: 4.5,
    fill: "#EDECE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16C14.006-.033 21.13-3.741 29.374 4.876M9 19.1c8-.88 12 4.087 12 14.9M9 18c4.765-8.657 10.115-11.69 16.05-9.096M30.509 21.898C27.43 24.332 25.5 28.644 25 34"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClustersArc);
export default __webpack_public_path__ + "static/media/clustersArc.fe1732bc391ba6d273ecb532d1b468d5.svg";
export { ForwardRef as ReactComponent };